import { mimeTypeIcon } from "../../../../../constants";
import { Item } from '../../../../../types/types';
import { ContentContext } from "../../../../../utils/contexts";

import {  ListItem, ListItemText, Divider, ListItemAvatar  } from "@mui/material";

interface SearchItemProps {
	item: Item;
}

class SearchItem extends window.React.PureComponent<SearchItemProps> {
	static contextType = ContentContext;

	onItemSelect = (item: Item) => {
		const { onItemSelect } = this.context;
		onItemSelect(item);
	};

	render() {
		const { item } = this.props;
		const { selected, hidden, loadingContent } = this.context;

		const isSelected = Boolean(selected[item.nodeRef]);
		const isHidden = Boolean(hidden[item.nodeRef]);

		const fileIconClass = mimeTypeIcon[item.mimetype];

		return (
			<React.Fragment>
				<ListItem
					disableRipple
					disableTouchRipple
					button
					key={item.nodeRef}
					onClick={() => this.onItemSelect(item)}
					selected={isSelected}
					disabled={item.disabled || isHidden || loadingContent}
					sx={{
						paddingLeft: '16px !important',
						paddingTop: 0,
						paddingBottom: 0,
					}}
				>
					<ListItemAvatar
						sx={{
							fontSize: '22px',
							minWidth: 'auto',
							marginRight: '10px',
							color: '#8e8e8e',
							'& .green': {
								color: 'green',
							},
							'& .red': {
								color: 'red',
							},
							'& .blue': {
								color: '#0e1f3e',
							},
						}}
					>
						<i className={`fas fa-${isSelected ? 'check-circle blue' : fileIconClass}`} />
					</ListItemAvatar>
					<ListItemText
						primary={item.name}
						secondary={
							item.path
								? item.path.every(pathEl => pathEl.name === '')
									? ''
									: item.path.map(pathEl => pathEl.name || pathEl).join('/')
								: null
						}
						primaryTypographyProps={{ sx: { fontSize: '13px', wordBreak: 'break-all' } }}
						secondaryTypographyProps={{ sx: { fontSize: '13px', wordBreak: 'break-all' } }}
					/>
				</ListItem>
				<Divider sx={{ margin: '0 !important' }} />
			</React.Fragment>
		);
	}
}

export default SearchItem;
